import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';
import { UtilsService } from '../../../core/services/utils';
import { OAuthConstants } from '../../constant/oAuth.constants';
import { GtSessionStorageService } from 'src/app/core/services/gt-session-storage.service';
import { LoginService } from 'src/app/core/services/login.service';
import { GtAppLoaderComponent } from '../../../core/components/gt-app-loader/gt-app-loader.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-callback',
    template: `
    <div class="redirect-callback">
      <gt-app-loader> </gt-app-loader>
    </div>`,
    imports: [GtAppLoaderComponent]
})
export class RedirectCallbackComponent implements OnInit {

  public errorMsg: string;
  private queryObj: any;
  private queryString: string;
  private accessToken: string;
  private destroyRef = inject(DestroyRef);

  constructor(private route: ActivatedRoute,
              private utilsService: UtilsService,
              private cookieService: CookieService,
              private gtSessionService: GtSessionStorageService,
              private loginService: LoginService) {
  }

  public ngOnInit() {
    this.route.fragment
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.queryString = params;
        if (params) {
          this.queryObj = this.utilsService.parseUrlString(params);
          if (this.queryObj.error === 'DOMAIN_UNKNOWN') {
            this.errorMsg = this.queryObj.error_description;
            console.error('error occurred while success redirect callback ', this.errorMsg);
          } else {
            this.accessToken = this.queryObj.access_token;
            this.doRedirect();
          }
        }
      });
  }

  private doRedirect() {
    this.loginService.addSessionCookie(this.accessToken)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        window.location.hash = '';
        const targetUrl = this.getTargetUrl();
        const context = {domain: window.location.host, targetUrl: targetUrl};
        const redirectUrl = this.utilsService.parseTemplateString(environment.redirectCallbacktemplate, context);
        window.location.href = redirectUrl;
      }, (error) => {
        console.error('error occurred while setting access token cookie', error);
      });
  }

  private getTargetUrl() {
    const userGenreatedTargetUrl = this.gtSessionService.value(OAuthConstants.TARGET_URL);
    const systemGenreatedTargetUrl = this.queryObj.targetUrl;
    const defaultHomeUrl = systemGenreatedTargetUrl === 'home' || systemGenreatedTargetUrl === 'v3/portal';
    const isUserGeneratedUrlValid = userGenreatedTargetUrl && userGenreatedTargetUrl.trim() !== '';

    if (isUserGeneratedUrlValid && defaultHomeUrl) {
        return userGenreatedTargetUrl;
    } else if (systemGenreatedTargetUrl && systemGenreatedTargetUrl !== 'null') {
        return systemGenreatedTargetUrl;
    }

    console.warn('no targetUrl exists');
    return '';
  }

}

